import type { RewardPools } from "../domain/types/index.js";

// 第15期。ドロー・回復・行動追加・一時除外を選び分ける。
export const REWARD_POOLS_FORESIGHT = {
  small: { workers: ["mid", "occupational-physician"], actions: ["village", "paid-leave", "cellar"] },
  medium: { workers: ["mid"], actions: ["work-triage", "smithy", "standup", "inn", "business-recovery"] },
  large: { workers: ["senior"], actions: ["improvement", "mobilize", "welfare"] },
} as const satisfies RewardPools;

// 第16期。復旧で必要になる回復・整理・安定出力を選び分ける。
export const REWARD_POOLS_RECOVERY = {
  small: { workers: ["mid", "occupational-physician"], actions: ["emergency-reassignment", "paid-leave"] },
  medium: { workers: ["mid"], actions: ["work-triage", "standup", "inn", "business-recovery"] },
  large: { workers: ["senior"], actions: ["welfare", "improvement", "training"] },
} as const satisfies RewardPools;

// 第17期。人材育成・反復実行・回復を組み合わせ、次の担い手へ仕事を渡す。
export const REWARD_POOLS_INHERITANCE = {
  small: { workers: ["mid", "occupational-physician"], actions: ["emergency-reassignment", "paid-leave", "sendoff"] },
  medium: { workers: ["mid"], actions: ["pair", "meeting", "inn", "business-recovery"] },
  large: { workers: ["senior"], actions: ["training", "collaboration-meeting", "improvement"] },
} as const satisfies RewardPools;

// 第18期。新卒を増やし、偏った手札を回転・出力へ変える選択肢を濃くする。
export const REWARD_POOLS_GRADUATION = {
  small: {
    workers: ["occupational-physician"],
    actions: ["mass-graduate-hiring", "placement-plan", "paid-leave"],
  },
  medium: {
    workers: ["mid"],
    actions: ["new-hire-onboarding", "work-standardization", "team-building", "inn"],
  },
  large: {
    workers: ["senior"],
    actions: ["training", "welfare", "lost-city"],
  },
} as const satisfies RewardPools;

// 第19期。窓際を残して活かす／変換する／負債として引き受ける施策を主役にする。
export const REWARD_POOLS_WINDOW_SEAT = {
  small: { workers: ["mid", "occupational-physician"], actions: ["spot-assignment", "paid-leave", "sendoff"] },
  medium: { workers: ["mid"], actions: ["psychological-counseling", "special-task-team", "headhunting", "stables"] },
  large: { workers: ["senior"], actions: ["improvement", "welfare", "training"] },
} as const satisfies RewardPools;

// 第20期。投資を早く選ぶほど後半で回収しやすいが、手数を支える施策も残す。
export const REWARD_POOLS_INVESTMENT = {
  small: { workers: ["mid"], actions: ["crisis-management-office", "paid-leave", "village"] },
  medium: { workers: ["occupational-physician"], actions: ["ai-adoption", "deadline-negotiation", "inn", "business-recovery"] },
  large: { workers: ["senior"], actions: ["advisor-contract", "improvement", "mobilize", "training"] },
} as const satisfies RewardPools;

export const REWARD_POOLS = {
  small: {
    workers: ["mid", "occupational-physician"],
    actions: ["village", "cellar", "field-judgment", "paid-leave", "sendoff", "mass-graduate-hiring", "placement-plan", "crisis-management-office"],
  },
  medium: {
    workers: ["mid", "occupational-physician"],
    actions: [
      "smithy", "pair", "standup", "team-building",
      "crash-work", "no-overtime-day", "workers-village", "villa",
      "meeting", "stables", "inn", "mid-career-hire",
      "work-triage",
      "business-recovery",
      "ai-adoption", "deadline-negotiation",
      "new-hire-onboarding", "work-standardization",
    ],
  },
  large: {
    workers: ["senior"],
    actions: [
      "policy", "welfare", "lab", "improvement", "mobilize",
      "bazaar", "lost-city", "city-quarter", "kings-court", "training", "collaboration-meeting", "advisor-contract",
    ],
  },
} as const satisfies RewardPools;

// 第12期「選択と集中」専用。テーマに合わせ各規模を絞る。
export const REWARD_POOLS_FOCUS = {
  small: {
    workers: ["mid"],
    actions: ["cellar", "field-judgment", "paid-leave"],
  },
  medium: {
    workers: ["mid"],
    actions: ["smithy", "standup", "meeting", "inn"],
  },
  large: {
    workers: ["senior"],
    actions: ["policy", "improvement", "bazaar", "training"],
  },
} as const satisfies RewardPools;

// 第11期「横展開」専用。各規模を労働者1種・施策3種の4種に絞る。
export const REWARD_POOLS_EXPANSION = {
  small: {
    workers: ["mid"],
    actions: ["village", "paid-leave", "sendoff"],
  },
  medium: {
    workers: ["mid"],
    actions: ["smithy", "crash-work", "team-building"],
  },
  large: {
    workers: ["senior"],
    actions: ["policy", "mobilize", "training"],
  },
} as const satisfies RewardPools;

// 第13期「連携と自律」専用。各規模4種の候補から選ばれる。
export const REWARD_POOLS_AUTONOMY = {
  small: {
    workers: ["mid"],
    actions: ["village", "paid-leave", "sendoff"],
  },
  medium: {
    workers: [],
    actions: ["pair", "team-building", "meeting", "inn"],
  },
  large: {
    workers: ["senior"],
    actions: ["policy", "mobilize", "training"],
  },
} as const satisfies RewardPools;

// 第14期「長期持久戦」専用。回復・継続・連携に寄せた各規模4種の候補。
export const REWARD_POOLS_ENDURANCE = {
  small: { workers: ["occupational-physician"], actions: ["paid-leave", "sendoff", "village"] },
  medium: { workers: ["mid"], actions: ["pair", "inn", "meeting"] },
  large: { workers: ["senior"], actions: ["policy", "training", "collaboration-meeting"] },
} as const satisfies RewardPools;
